export default __webpack_public_path__ + "static/lead-all-b67549dcc1db487f0205e7abfbda1f19.png";